import {
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  InjectionToken,
  QueryList,
  forwardRef,
  signal,
} from '@angular/core';

import { StepComponent } from './step/step.component';

export const SS_STEPPER = new InjectionToken<StepperComponent>(
  'Stepper Component'
);

@Component({
  selector: 'ss-www-stepper',
  imports: [],
  template: `<ng-content select="ss-www-step"></ng-content>`,
  styleUrl: './stepper.component.scss',
  providers: [{ provide: SS_STEPPER, useExisting: StepperComponent }],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepperComponent {
  _steps = signal<StepComponent[] | null>(null);
  @ContentChildren(forwardRef(() => StepComponent))
  set steppers(steppers: QueryList<StepComponent>) {
    this._steps.set(steppers.toArray());
  }
}
